export enum AuthRouteKeys {
  Root = '/auth',
  Login = '/auth/login',
  OTP = '/auth/otp',
  NewPassword = '/auth/new-password',
  NewPasswordVerifByEmail = '/auth/new-password-verify-by-email',
}

export enum ErrorRouteKeys {
  Root = '/error',
  NotFound = '/error/404',
  Internal = '/error/500',
  NotAccess = '/error/403',
}

export enum MainRouteKeys {
  Root = '/',
  Personal = '/personal',
  PersonalInfo = '/personal/info',
  PersonalFinancialLimits = '/personal/financial-limits',
  PersonalTwoFaSecurity = '/personal/two-fa-security',
  PersonalBalance = '/personal/balance',
  PersonalReward = '/personal/reward',
  PersonalRewardManage = '/personal/reward/manage',
  DepositFromMoraPay = '/personal/reward/deposit-from-morapay',
  WithdrawToMoraPay = '/personal/reward/withdraw-to-morapay',
  PersonalChangePassword = '/personal/change-password',
  BankManagement = '/request-withdraw/bank-management',
  PersonalLogout = '/personal/logout',
  Users = '/users',
  UpdateUser = '/update-user',
  Balance = '/balance',
  BalanceManage = '/balance/manage',
  Transfers = '/balance/transfers',
  TopUp = '/balance/topup',
  TransfersToBank = '/balance/transfers-to-bank',
  TransfersToBankBIDV = '/balance/transfers-to-bank-bidv',
  PayBill = '/pay-bill',
  PayBillElectric = '/pay-bill/electric',
  PayBillElectricDetails = '/pay-bill/electric/:orderCode',
  Transactions = '/transactions',
  TransactionBills = '/transactions/bills',
  TransactionBillDetails = '/transactions/bills/:transactionCode',
  Customers = '/customers',
  PointTransactions = '/transactions/points',
  PointTransactionDetails = '/transactions/points/:transactionCode',
  PointRewardTransactions = '/transactions/point-reward-transactions',
  Orders = '/orders',
  TPBank = '/tpbank',
  TransactionsBank = '/transactionsbank',
  AccountBank = '/accountTPBank',
  RequestWithdraw = '/request-withdraw',
  RequestWithdrawOwn = '/request-withdraw/request-withdraw-own',
  RequestWithdrawOwnDetail = '/request-withdraw/request-withdraw-own/:id',
  CheckRequestWithdrawList = '/request-withdraw/check-request-withdraw',
  CheckRequestWithdrawDetail = '/request-withdraw/check-request-withdraw/:id',
  CreateRequestWithdraw = '/request-withdraw/create-request-withdraw',
  CompanyDepartment = '/company-department',
  Company = '/company-department/company',
  Refferal = '/refferal',
  RefferalDetail = '/refferal/manage',
  RefferalDetailHistory = '/refferal/history',
  AuditLogsAdmin = '/audit-logs-admin',
  // Energy Department Routes
  EnergyDepartment = '/energy-department',
  SupplierEnergy = '/energy-department/supplier',
  GasStation = '/energy-department/oil-store',
  BranchEnergy = '/energy-department/branch',
  TransactionEnergy = '/energy-department/transactions',
  // Transaction legacy routes
  TransactionDetail = '/transaction/:id',
  TransactionDemo = '/transactions/demo',
  TransactionWithdraws = '/transactions/withdraws',
  TransactionDepositSupport = '/transactions/deposit-support',
  TransactionAdminWithdraws = '/transactions/transactions-withdraw-to-admin-wallet',
  // User legacy routes
  UserDetail = '/user/:id',
  TopUpPoints = '/top-up-points',
  TransferToUser = '/transfer-to-user',
  TransferList = '/transfers',
  // Report routes
  ReportSystem = '/reports/system',
  OrdersOverview = '/orders-overview',
  // Server config routes
  WithdrawConfig = '/server-config/withdraw',
  MaintenanceConfig = '/server-config/maintenance',
  SettingChangePassword = '/setting/change-password',
  Announcement = '/server-config/announcement',
  CreateAnnouncement = '/server-config/announcement/create',
  EditAnnouncement = '/server-config/announcement/edit',
  // Misc legacy routes
  ClaimList = '/claim',
  ElectricBill = '/electric-bill',
  ElectricBillUploadFile = '/electric-bill-upload-file',
  // BIDV Virtual Account Routes
  BidvVirtualAccount = '/bidv-virtual-account',
  BidvVirtualAccountInquiry = '/bidv-virtual-account/inquiry',
  BidvTransHistory = '/bidv-virtual-account/trans-history',
  // BIDV Bank Transfer Routes
  BidvBankTransfer = '/bidv-bank-transfer',
  BidvBankTransferReconciliation = '/bidv-bank-transfer/reconciliation',
  BidvBankTransferWhitelist = '/bidv-bank-transfer/whitelist',
  BidvTransferDestWhitelist = '/bidv-bank-transfer/dest-whitelist',
  // BIDV Transfer With Evidence Routes
  BidvTransferWithEvidence = '/bidv-transfer-with-evidence',
  BidvTransferWithEvidenceCreate = '/bidv-transfer-with-evidence/transfer-with-evidence/create',
  BidvTransferWithEvidenceOwn = '/bidv-transfer-with-evidence/own',
  BidvTransferWithEvidenceAll = '/bidv-transfer-with-evidence/all',
  BidvTransferWithEvidenceDetails = '/bidv-transfer-with-evidence/details/:id',
  Settings = '/settings',
  AppVersionConfig = '/settings/app-version',
  UnlockSmsRateLimit = '/settings/unlock-sms-rate-limit',
  BalanceOperationControls = '/settings/balance-operation-controls',
}

export const MainRouteHelpers = {
  transactionDetail: (id: string) => `/transaction/${id}`,
  requestWithdrawOwnDetail: (id: string) =>
    `/request-withdraw/request-withdraw-own/${id}`,
  checkRequestWithdrawDetail: (id: string) =>
    `/request-withdraw/check-request-withdraw/${id}`,
  userDetail: (id: string) => `/user/${id}`,
  ordersOverview: (fromDate: string, toDate: string) =>
    `/orders-overview?fromDate=${fromDate}&toDate=${toDate}`,
};
